// extracted by mini-css-extract-plugin
export default {"tagStyle":"styles_tagStyle__-1vbw","plusTag":"styles_plusTag__Xt1fk","input":"styles_input__Jl9kZ"};